import { useNotificationContext } from '@context/NotificationContext';
import SavedEmailStatusEnum from 'common/constants/SavedEmailStatusEnum';
import { validateEmail } from 'utils/validateField';
import { ArrowLeftIcon, Button, IconButton, PaperFooter, PlusIcon, Scrollbars, SettingsIcon, Typography, } from '@onsolve/onsolve-ui-components';
import React, { useCallback, useEffect, useState } from 'react';
import EmailField from './EmailField/EmailField';
import styles from './NotificationSettings.module.scss';
import RenderBanner from './RenderBanner/RenderBanner';
import { i18n } from '@lingui/core';
const MAX_EMAIL_ADDRESS_FIELDS = 10;
const NotificationSettings = ({ handleSettingsClick, userUuid }) => {
    const { emailAddresses, isEmailSaved, setIsEmailSaved, saveEmailAddress } = useNotificationContext();
    const [isMessageBoxOpen, setIsMessageBoxOpen] = useState(false);
    const [changedEmail, setChangedEmail] = useState([]);
    const [errorMessages, setErrorMessages] = useState([]);
    useEffect(() => {
        setChangedEmail(emailAddresses);
    }, []);
    const handleCancel = useCallback(() => {
        handleSettingsClick();
    }, [handleSettingsClick]);
    const handleSave = async (event) => {
        event.preventDefault();
        const errors = validateEmails(changedEmail);
        if (errors.length > 0) {
            setIsEmailSaved(SavedEmailStatusEnum.ERROR);
            handleOnOpen();
            return;
        }
        await saveEmailAddress(userUuid, changedEmail);
        handleOnOpen();
    };
    const handleAdd = () => {
        setChangedEmail([...changedEmail, '']);
    };
    const handleRemove = (indexToRemove) => {
        const newEmails = changedEmail?.filter((email, index) => indexToRemove !== index);
        const newErrors = validateEmails(newEmails);
        setChangedEmail(newEmails);
        setErrorMessages(newErrors);
        setIsMessageBoxOpen(isMessageBoxOpen && !!newErrors.filter((error) => error.key !== indexToRemove).length);
    };
    const validateEmails = (emails = []) => {
        // filter out undefined errors
        const invalidEmails = emails.map(validateEmail).filter((error) => error.errorMessage);
        const emailErrors = emails?.length ? invalidEmails : [];
        setErrorMessages(emailErrors);
        return emailErrors;
    };
    const handleChange = (index, event) => {
        const { value } = event.target;
        changedEmail[index] = value;
        setChangedEmail([...changedEmail]);
    };
    const handleOnClose = () => setIsMessageBoxOpen(false);
    const handleOnOpen = () => setIsMessageBoxOpen(true);
    return (<div className={styles.settings_container} data-testid="NotificationSettings">
            <div className={styles.settings_title}>
                <IconButton onClick={handleCancel}>
                    <ArrowLeftIcon size="md" className={styles.settings_title_arrowIcon}/>
                </IconButton>
                <SettingsIcon size={'sm'} color="primary" aria-hidden={true} className={styles.settings_settingsIcon}/>
                <span className={styles.settings_titleName}>{i18n._(`ng_announcements_announcements`)}</span>
            </div>

            <RenderBanner messages={errorMessages.map((error) => error.errorMessage)} isEmailSaved={isEmailSaved} isMessageBoxOpen={isMessageBoxOpen} handleOnClose={handleOnClose}/>

            <div className={styles.settings_manage}>
                <Typography variant="p14" className={styles.settings_manage_title}>
                    {i18n._(`ng_common_notificationSettingsManageTitle`)}
                </Typography>
                <div className={styles.settings_manage_description}>
                    <span>{i18n._('ng_common_notificationSettingsManageDescription')}</span>
                </div>
            </div>

            <div className={styles.settings_emailWrapper}>
                {<form>
                        <Scrollbars autoHeight autoHeightMin="0" autoHeightMax="15rem">
                            {changedEmail.map((email, index) => (<EmailField key={index} index={index} data={email} removeEmail={() => handleRemove(index)} handleChange={handleChange} errors={errorMessages}/>))}
                        </Scrollbars>
                        <IconButton disabled={changedEmail.length >= MAX_EMAIL_ADDRESS_FIELDS} className={`${styles.settings_addButton} ${styles.settings_addButton_text}`} onClick={handleAdd}>
                            <PlusIcon className={styles.settings_addButton_plusIcon}/>
                            {i18n._(`ng_common_notificationSettingsAddEmail`)}
                        </IconButton>
                        <PaperFooter className={styles.settings_footer}>
                            <Button color="secondary" className={styles.settings_text_Uppercase} onClick={handleCancel}>
                                {i18n._('ng_common_cancel')}
                            </Button>
                            <Button color="primary" onClick={handleSave} type="submit" className={`${styles.settings_text_Uppercase} ${styles.settings_moveButton}`}>
                                {i18n._('ng_generic_save')}
                            </Button>
                        </PaperFooter>
                    </form>}
            </div>
        </div>);
};
export default NotificationSettings;
